<button
  type="button"
  class="tour-start-button"
  aria-label="Start tour"
  title="Take tour"
  matTooltip="Take tour"
  matTooltipPosition="left"
  (click)="startTour()"
>
  <mat-icon>rocket_launch</mat-icon>
</button>

<div class="tour-overlay" *ngIf="activeStep">
  <div class="tour-backdrop"></div>
  <div
    class="tour-highlight"
    *ngIf="targetRect && showHighlight"
    [ngClass]="highlightClass"
    [ngStyle]="getHighlightStyle()"
  ></div>
  <section
    class="tour-popover"
    *ngIf="isPositionReady"
    [ngClass]="[
      popoverPlacement,
      activeStep?.id === 'complete' ? 'tour-popover--complete' : '',
      shouldShowCharacterLayout() ? 'tour-popover--with-character' : '',
      getCharacterPositionClass(),
      getTargetStyleClass()
    ]"
    [ngStyle]="cardStyle"
  >
    <div class="tour-popover__layout" *ngIf="activeStep?.id !== 'complete'">
      <div class="tour-popover__content">
        <div class="tour-popover__eyebrow">Setup tour</div>
        <h3>{{ activeStep.title }}</h3>
        <p *ngIf="activeStep.body">{{ activeStep.body }}</p>
        <div class="tour-popover__points" *ngIf="activeStep.featurePoints?.length">
          <div class="tour-point" *ngFor="let point of activeStep.featurePoints">
            <div class="tour-point__icon" [ngClass]="point.iconClass">
              <mat-icon *ngIf="point.icon !== 'T'">{{ point.icon }}</mat-icon>
              <span *ngIf="point.icon === 'T'">{{ point.icon }}</span>
            </div>
            <div class="tour-point__text">
              <strong>{{ point.label }}</strong>
              <span>{{ point.description }}</span>
            </div>
          </div>
        </div>
        <div class="tour-popover__note" *ngIf="activeStep.footerNote">
          <mat-icon>rocket_launch</mat-icon>
          <span>{{ activeStep.footerNote }}</span>
        </div>
        <div class="tour-popover__actions">
          <button type="button" class="tour-popover__link" (click)="stopTour()">
            Skip
          </button>
        </div>
      </div>
      <figure class="tour-popover__character" *ngIf="shouldShowCharacterLayout()">
        <img [src]="getTourCharacterAsset()" alt="Tour guide character" />
      </figure>
    </div>
    <div class="tour-complete" *ngIf="activeStep?.id === 'complete'">
      <div class="tour-complete__hero">
        <div class="tour-complete__content">
          <div class="tour-popover__eyebrow">Setup tour</div>
          <h3>{{ activeStep.title }}</h3>
          <p>{{ activeStep.body }}</p>
          <p class="tour-complete__secondary" *ngIf="activeStep?.secondaryBody">
            {{ activeStep?.secondaryBody }}
          </p>
          <div class="tour-complete__actions">
            <button
              type="button"
              class="tour-popover__primary tour-complete__primary"
              (click)="continueTour()"
            >
              {{ activeStep.actionLabel }}
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
        <div class="tour-complete__visual">
          <div class="tour-complete__confetti tour-complete__confetti--one"></div>
          <div class="tour-complete__confetti tour-complete__confetti--two"></div>
          <div class="tour-complete__confetti tour-complete__confetti--three"></div>
          <div class="tour-complete__orb"></div>
          <figure class="tour-complete__character">
            <img [src]="getTourCharacterAsset()" alt="Tour guide character" />
          </figure>
        </div>
      </div>
      <div class="tour-complete__footer" *ngIf="activeStep?.completionItems?.length">
        <div class="tour-complete__item" *ngFor="let item of activeStep.completionItems">
          <div class="tour-complete__item-badge">
            <span class="tour-complete__item-check">
              <span>✓</span>
            </span>
            <div class="tour-point__icon" [ngClass]="item.iconClass">
              <mat-icon>{{ item.icon }}</mat-icon>
            </div>
          </div>
          <div class="tour-complete__item-text">
            <strong>{{ item.label }}</strong>
            <span>{{ item.description }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
